package com.solevo.dist.network.api.invoice

import com.solevo.dist.application.models.Invoice
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface InvoiceRemoteSource {
    fun getInvoicesForOrderLive(orderId: String): Flow<List<Invoice>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getInvoice(id: String): Flow<Invoice?> = flow { throw DefaultRemoteSourceImplementationException() }
}